import React, { Component } from 'react'
import nesProp from 'nested-property'
import styles from './DSWizardHelper.scss'
import documentStyles from './documents.scss'
import cs from 'classnames'
import i18n from 'lib/i18n'
import * as c from 'state/constants'
import { shouldEditThePackage, stakeholdersCanSign, stakeholdersNeedInvitation } from './documentsHelpers'
import DsPackageLinkAndUploadButton from './linkToContractAndUploadDocuments/DsPackageLinkAndUploadButton'

// variables out of module
const _ = i18n('dsdocuments')

/**
 * This module wraps buttons that needs to be rendered  on the documents list
 */
export default class DsListButtonsWrapper extends Component {
    static propTypes = {
        dsPackage: React.PropTypes.object,
        templates: React.PropTypes.array,
        isDsList: React.PropTypes.bool,
        // openLinkAndUploadWizard: React.PropTypes.func,
        method: React.PropTypes.func,
        key: React.PropTypes.string,
        canCreateMifid: React.PropTypes.bool,
        forceOpenInvitationEditor: React.PropTypes.bool,
    }

    constructor(props) {
        super(props)
        this.state = {
            dsPackage: {}
        }
    }
    /**
     * Checks if package has stakeholders that haven't signed yet
     * @param {*} dsPackage
     * @returns Boolean
     */
    hasUnfinishedStakeholder(dsPackage) {
        let hasUnfinishedStakeholder = false
        dsPackage.dsStakeholders.map(oneStakeholder => {
            if (!oneStakeholder.finished && oneStakeholder.signerType !== "BROKER") {
                hasUnfinishedStakeholder = true
            }
        })
        return hasUnfinishedStakeholder
    }

    /**
     * This function helps to use an icon on a safe way
     */
    getIcon = (menuName, isWhite = false) => {
        try {
            return isWhite ? require(`resources/images/m-${menuName}.svg`) : require(`resources/images/icn-${menuName}.svg`)
        } catch (err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    render() {
        const { dsPackage, method, isDsList, sendRemindersMethod, directSignMethod, canCreateMifid, zoomTo, showInvitation, sendInvitationMethod } = this.props

        let isEditableThePackage = shouldEditThePackage(
            nesProp.get(dsPackage, "statusHistory"),
            nesProp.get(dsPackage, "isEditable")
        )

        let blocked = false
        const statusBlackList = ['packageStatusExpired', 'packageStatusRejected', 'packageStatusRevoked', 'packageStatusFailed',
            'packageStatusFinished', 'documentsDownloaded', 'documentsTransferredToOracle', 'documentError',
            'packageStatusDeleted', 'packageStatusDraft', 'emailSentWithSignedDocs', 'generalError', 'printed'
        ]
        if (dsPackage && dsPackage.statusHistory) {
            dsPackage.statusHistory.forEach((oneStatus) => {
                if (statusBlackList.includes(oneStatus.status)) {
                    blocked = true
                }
            })
        }

        let packageStatusError = dsPackage.status === c.DS_DOCUMENTS_GENERAL_ERROR || blocked

        return (
            <div className={cs(documentStyles.dsListButtonsWrapper)}>

                <div className={cs(documentStyles.marginBot, documentStyles.linkButton)}>
                    <DsPackageLinkAndUploadButton
                        packageIsEditable={dsPackage.isisEditable}
                        dsPackage={dsPackage}
                        openLinkAndUploadWizard={(dsPackage) => {
                            return method(dsPackage)
                        }}
                    />
                    {/* {oneDoc && oneDoc.uploadedToOracle ? _("documentAlreadyUploaded") : ""} */}

                </div>
                {
                    !packageStatusError &&
                    isDsList && dsPackage.mustBeSigned && !dsPackage.hasFinishStatus
                    && this.hasUnfinishedStakeholder(dsPackage)
                    && !shouldEditThePackage(dsPackage.statusHistory, dsPackage.isEditable)
                    && !stakeholdersNeedInvitation(dsPackage)
                    && (
                        <div className={cs(documentStyles.marginBot, documentStyles.grow)}>
                            <button className={cs(documentStyles.greenButton, documentStyles.greenButtonDsList, "enabled", documentStyles.grow)}
                                onClick={(ev) => {
                                    ev.stopPropagation()
                                    return sendRemindersMethod(dsPackage.id)
                                }
                                }>{_('sendRemindersButton')}</button>
                        </div>
                    )
                }

                {!packageStatusError &&
                    showInvitation && isDsList && dsPackage.mustBeSigned && !dsPackage.hasFinishStatus &&
                    stakeholdersNeedInvitation(dsPackage) &&
                    !shouldEditThePackage(dsPackage.statusHistory, dsPackage.isEditable) &&
                    <div className={cs(documentStyles.marginBot, documentStyles.grow)} key={"invitationeditable" + dsPackage.id}>
                        <div
                            key={"btnMifid"}
                            className={cs(documentStyles.greenButton, documentStyles.greenButtonDsList, "enabled", styles.grayButtonFlex, styles.mifidButton, documentStyles.grow /*(disabled ? styles.disabled : '')*/)}
                            onClick={(e) => {
                                e.stopPropagation()
                                sendInvitationMethod(dsPackage.id)
                            }}
                        >
                            <img className={cs(documentStyles.emailButtonIcon)} src={this.getIcon('inbox', true)} /> {_('customizeInvitationEmail')}
                        </div>
                    </div>
                }

                {!packageStatusError && !isEditableThePackage && dsPackage.mustBeSigned && stakeholdersCanSign(dsPackage) &&
                    <div className={cs(documentStyles.marginBot, documentStyles.grow)}>
                        <button className={cs(documentStyles.greenButton, documentStyles.greenButtonDsList, "enabled", documentStyles.grow)}
                            onClick={(ev) => {
                                ev.stopPropagation()
                                return directSignMethod(dsPackage.id)
                            }
                            }>{_("directSignButton")}</button>
                    </div>
                }
                {isEditableThePackage && canCreateMifid &&
                    <div className={cs(documentStyles.marginBot, documentStyles.grow)} key={"mifidButton"}>
                        <div
                            key={"btnMifid"}
                            className={cs(documentStyles.greenButton, documentStyles.greenButtonDsList, "enabled", styles.grayButtonFlex, styles.mifidButton, documentStyles.grow /*(disabled ? styles.disabled : '')*/)}
                            onClick={(e) => {
                                e.stopPropagation()
                                zoomTo(dsPackage, true)
                            }}
                        >
                            <img className={cs(documentStyles.emailButtonIcon)} src={this.getIcon('dsdocuments-white')} /> {_('resumeToEdit')}
                        </div>
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/dsListButtonsWrapper.jsx